<template>
  <div class="w-full flex items-center justify-center">
    <hr class="w-full" />
    <span class="uppercase shrink-0 px-4 text-grey-1">
      {{ $t('or') }}
    </span>
    <hr class="w-full" />
  </div>
</template>
